/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { CommentThreadModule } from '../comment-thread/comment-thread.module';
import { ItemActionsModule } from '../item-actions/item-actions.module';
import { CommunityFeedModule } from '../common/community/feed/community-feed.module';
import { UtCategoryLinkModule } from '../common/community/feed/category-link/category-link.module';
import { ForumsPageComponent } from './forums-page.component';
import { TopicPageComponent } from './topic-page.component';
import { EmojiHtmlPipe } from '../pipes/emoji-html.pipe';
import { EmojiTextPipe } from '../pipes/emoji-text.pipe';

// Not standalone, for the same reason as CommunityFeedModule: the action bar and the comment thread pull in
// UpgradeModule.
@NgModule({
  imports: [CdkMenuModule, CommonModule, UIRouterModule, SharedModule, CommonComponentsModule, CommentThreadModule, ItemActionsModule, CommunityFeedModule, UtCategoryLinkModule, EmojiHtmlPipe, EmojiTextPipe],
  declarations: [ForumsPageComponent, TopicPageComponent],
  exports: [ForumsPageComponent, TopicPageComponent],
})
class ForumsPageModule {}

export { ForumsPageModule };
